export const ASILIFLOW_SUPPORT_EMAIL = 'support@getasili.com'
export const ASILIFLOW_SUPPORT_MAILTO = `mailto:${ASILIFLOW_SUPPORT_EMAIL}`
export const ASILIFLOW_DEMO_CONTACT_PATH = '/contact?intent=demo'
export const ASILIFLOW_SUPPORT_CONTACT_PATH = '/contact?intent=support'
